import React from "react";
import  { useDispatch } from "react-redux";
import { Blade, Button } from "rhombus-react";

import useActiveCreative from "hooks/useActiveCreative";

import { closeModal } from 'reducers/Modal';

export default function ViewEncodes(props){
	let dispatch = useDispatch()
		, { creatives } = props
		, [creative] = creatives
		, videos = creative?.videos || []
		, modalTitle = `View Encodes - ${creative?.name || ''}`
		, onClose = () => dispatch(closeModal())
		;

	useActiveCreative(creatives[0]?.id);

	const renderContent = () => (
		<ul className="encode-list">
			{(videos).map((link) => {
				return (
					<li key={link} title="View Encode">
						<a href={`${link}`} target="_BLANK">{link}</a>
					</li>
				);
			}) }
		</ul>
	);

	const renderFooter = () => ([
		<Button key="cancel" theme="grey" onClick={onClose}>Close</Button>,
	]);

	return (
		<Blade
			type={"modal"}
			setAppTitle={false}
			className={'view-encodes-modal'}
			title={modalTitle}
			allowFullScreen={false}
			xClose
			bladeProps={{ verticallyCenter: true }}
			onClose={onClose}
			renderContent={renderContent}
			renderFooter={renderFooter}
		/>
	);
}

ViewEncodes.displayName = "ViewEncodes";

ViewEncodes.defaultProps = {
	creatives:[],
};
